import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSourceItemsService } from '../../../../../data-source/data-source-items/services/data-source-items.service';
import { ILinkBannerTileDefinition } from '../../../../interfaces/tiles/definitions/link-banner-tile-definition.interface';
import { ITileComponent } from '../../tile-component.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-link-banner-tile',
  templateUrl: './link-banner-tile.component.html',
  styleUrls: ['./link-banner-tile.component.scss'],
})
export class LinkBannerTileComponent implements ITileComponent, OnInit, AfterViewInit, OnDestroy {
  @Input() tileInstance: ILinkBannerTileDefinition;

  displayNumber: number;
  ticking = false;

  private targetNumber: number;
  private unsubscribe$ = new Subject<boolean>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private dataSourceItemsService: DataSourceItemsService,
  ) {}

  async ngOnInit() {
    this.displayNumber = 0;

    // TODO: Workaround until we can count Tenders properly
    if (!this.tileInstance?.displayFeatureTotal) {
      return;
    }
    if (this.tileInstance.displayFeatureTotal === 'tenders') {
      this.targetNumber = null;
    } else {
      this.targetNumber = await this.dataSourceItemsService.getCount(
        this.tileInstance.displayFeatureTotal,
      );
    }

    interval(10)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.displayNumber = this.displayNumber + (this.targetNumber - this.displayNumber) * 0.04;
      });
  }

  ngAfterViewInit() {
    this.ticking = true;
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  get shouldShowCard(): boolean {
    const displayProperties = this.tileInstance?.displayProperties as
      | { noCard?: boolean; isCard?: boolean }
      | undefined;
    if (displayProperties?.noCard !== undefined) {
      return !displayProperties.noCard;
    }
    if (displayProperties?.isCard !== undefined) {
      return displayProperties.isCard;
    }
    return true;
  }
}
